<template>
  <div class="left-chart">
    <div class="lc1-header">垃圾分类排行</div>
    <dv-decoration-2 style="height:10px;" />
    <check-date @getDate="getDate" />
    <scroll-board :dateValue="dateValue" />
  </div>
</template>

<script>
import scrollBoard from './scrollBoard'
import CheckDate from './CheckDate'

export default {
  name: 'LeftChart',
  components: {
    scrollBoard,
    CheckDate
  },
  data () {
    return {
      dateValue: ''
    }
  },
  methods: {
    getDate(data){
      this.dateValue = data;
    }
  }
}
</script>

<style scoped lang="less">
.left-chart {
  width: 100%;
  height: 100%;

  .lc1-header {
    text-align: center;
    height: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/datav/LeftChart.vue